import React from "react";

// Reusable hand-drawn arrow (Caveat vibe). Rotatable via className.
export default function HandArrow({ className = "", color = "#0C0C0C" }) {
  return (
    <svg viewBox="0 0 120 80" fill="none" className={className} aria-hidden="true">
      <path
        d="M5 20 C 40 5, 80 8, 104 40"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M104 40 L 88 30 M104 40 L 92 54"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
